import {useContext} from 'react'
import {ClassificationReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {CLASSIFICATION_REPORT_COLUMNS} from '../../utils'
import ClassificationReportRow from './ClassificationReportRow'
import {parseClassificationReportRow} from '../../parsings'

const ClassificationReportTable = () => {
  const {reportData, isLoading, filters, onSortingChange} = useContext(ClassificationReportContext)

  return (
    <div className='sticky-table-wrapper'>
      <div className='table-responsive-wrapper'>
        <div className='table-responsive'>
          <DynamicTable
            data={reportData}
            sortableColumns={CLASSIFICATION_REPORT_COLUMNS}
            loading={isLoading}
            TableRow={ClassificationReportRow}
            noDataMessage='No classification reports found'
            filters={filters}
            onSortingChange={onSortingChange}
            tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
            tableHeaderClass='sticky-table-header'
            rowParsingFunction={parseClassificationReportRow}
          />
        </div>
      </div>
    </div>
  )
}

export default ClassificationReportTable
